import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { includes, without } from 'lodash';
import { InformationPopupDialog } from './InformationPopupDialog';
import { informationPopupAction } from 'action/informationPopupAction';
import { get } from 'lodash';

export class InformationPopupContext extends Component {

  static propTypes = {
    children: PropTypes.any
  };

  static childContextTypes = {
    registerInformationPopupContextType: PropTypes.func,
    unregisterInformationPopupContextType: PropTypes.func,
    showInformationPopup: PropTypes.func,
    hideInformationPopup: PropTypes.func
  };

  static className = 'esk-information-popup-context';

  getChildContext = () => {
    return {
      registerInformationPopupContextType: this.registerInformationPopupContextType,
      unregisterInformationPopupContextType: this.unregisterInformationPopupContextType,
      showInformationPopup: this.showPopup,
      hideInformationPopup: this.hidePopup
    };
  }

  get contentUrl() {
    return get(this.state, 'contentDataModel.contentUrl');
  }

  state = {
    contextType: null,
    contentDataModel: null
  };

  _contextCodes = [];

  render() {
    const { children } = this.props;

    return (
      <div className={InformationPopupContext.className}>
        {children}

        <InformationPopupDialog
          display-if={this.contentUrl}
          contentUrl={this.contentUrl}
          onStopShowing={this.handleDismissPopup}
          onClose={this.hidePopup}
        />
      </div>
    );
  }

  registerInformationPopupContextType = (contextType) => {
    this._contextCodes.push(contextType);
  }

  unregisterInformationPopupContextType = (contextType) => {
    this._contextCodes = without(this._contextCodes, contextType);
  }

  showPopup = async (contextType) => {
    if (!this._isValidContext(contextType)) {
      return;
    }

    try {
      const contentDataModel  = await informationPopupAction.getPopupContent(contextType);
      const validationResult = await informationPopupAction.validatePopupContent(contentDataModel.contentUrl);

      if (validationResult.success) {
        this.setContextUrl(contextType, contentDataModel);
      }
    } catch (e) {
      this.unregisterInformationPopupContextType(contextType);
    }
  }

  hidePopup = () => {
    this.setState({ contextType: null, contentDataModel: null });
  }

  handleDismissPopup = () => {
    const { contentDataModel } = this.state;
    if (!get(contentDataModel, 'dataModel')) {
      return;
    }

    informationPopupAction.dismissPopup(contentDataModel.dataModel);
    this.hidePopup();
  }

  setContextUrl = (contextType, contentDataModel) => {
    if (this._isValidContext(contextType)) {
      this.setState({ contextType, contentDataModel });
    }
  }

  _isValidContext = (contextType) => includes(this._contextCodes, contextType);

}
